import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, type SxProps, type Theme } from "@mui/material";

type Props = {
  "aria-label": string;
  onClick: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

export default function RemoveIconButton({
  "aria-label": ariaLabel,
  onClick,
  disabled,
  sx,
}: Props) {
  return (
    <IconButton size="small" aria-label={ariaLabel} onClick={onClick} disabled={disabled} sx={sx}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
}
